<template>
  <el-dialog
    title="选择门店"
    width="70%"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :append-to-body="true"
  >
    <div class="dialog-header mb20 flex flex-between flex-center">
      <div class="flex flex-center">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入门店名称/关键词搜索"
          clearable
          size="small"
          style="width: 260px; margin-right: 10px;"
          @keyup.enter.native="doSearch"
        >
        </el-input>
        <el-button type="primary" size="small" @click="doSearch">搜索</el-button>
      </div>
      <div class="selected-info">
        已选择 <span class="highlight">{{ currentSelection.length }}</span> 家门店
      </div>
    </div>

    <div class="mb20">
      <el-table
        stripe
        border
        height="400"
        ref="shopTable"
        @row-click="toggleRowSelection"
        @selection-change="onSelectionChange"
        :data="pagedShopList"
        :row-key="getRowKey"
        style="width: 100%"
        size="small"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column type="index" :index="calcIndex" label="序号" width="60" align="center"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="门店名称"
          prop="shopName"
          min-width="150"
        >
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="门店编码"
          prop="shopId"
          min-width="120"
        >
        </el-table-column> -->
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="hm-pagination">
      <el-pagination
        background
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <div class="flex flex-center mt20">
      <el-button size="small" type="primary" @click="confirmSelection">确 定</el-button>
      <el-button size="small" @click="cancelSelection">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ShopPickerDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    shopList: {
      type: Array,
      default: () => []
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      currentSelection: [],
      pagedShopList: [],
      filteredShopList: [],
      searchKeyword: '',
      ignoreSelectionChange: false  // 标记是否忽略 selection-change 事件
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.openDialog();
      } else {
        // 弹窗关闭时重置状态
        this.currentSelection = [];
        this.pagedShopList = [];
      }
    }
  },
  methods: {
    // 打开弹窗初始化
    openDialog() {
      this.page = 1;
      this.searchKeyword = '';
      this.ignoreSelectionChange = true;
      // 过滤掉 shopId 为 "直营店" 和 "加盟店" 的数据
      this.filteredShopList = this.shopList.filter(shop => {
        const shopId = shop.shopId || shop.id;
        return shopId !== '直营店' && shopId !== '加盟店';
      });

      // 初始化已选项 - 从传入的 selectedIds 中匹配完整门店对象
      const selectedIdSet = new Set(this.selectedIds.map(id => String(id)));
      console.log('openDialog - selectedIds:', this.selectedIds.length, 'filteredShopList:', this.filteredShopList.length);
      this.currentSelection = this.filteredShopList.filter(shop => {
        const shopId = String(shop.shopId || shop.id);
        return selectedIdSet.has(shopId);
      });
      console.log('openDialog - currentSelection:', this.currentSelection.length);

      this.updatePagedData().then(() => {
        // 延迟设置初始选中状态，确保表格已渲染
        setTimeout(() => {
          this.setInitialSelection();
        }, 100);
      });
    },
    // 设置表格初始选中状态（只在打开弹窗时调用一次）
    setInitialSelection() {
      this.syncPageSelection();
    },
    // 同步当前页的选中状态（用于初始化和分页切换）
    syncPageSelection() {
      this.ignoreSelectionChange = true;
      try {
        if (!this.$refs.shopTable) return;

        const selectedIdSet = new Set(this.currentSelection.map(s => String(s.shopId || s.id)));
        console.log('syncPageSelection - currentSelection:', this.currentSelection.length, 'pagedShopList:', this.pagedShopList.length);

        // 先清空当前页的选中状态
        this.pagedShopList.forEach(row => {
          this.$refs.shopTable.toggleRowSelection(row, false);
        });

        // 再设置应该选中的行
        let selectedCount = 0;
        this.pagedShopList.forEach(row => {
          const rowId = String(row.shopId || row.id);
          if (selectedIdSet.has(rowId)) {
            this.$refs.shopTable.toggleRowSelection(row, true);
            selectedCount++;
          }
        });
        console.log('syncPageSelection - selectedCount:', selectedCount);
      } finally {
        this.ignoreSelectionChange = false;
      }
    },
    // 更新分页数据
    updatePagedData() {
      this.total = this.filteredShopList.length;
      const start = (this.page - 1) * this.size;
      const end = start + this.size;
      this.pagedShopList = this.filteredShopList.slice(start, end);
      // 返回 Promise 以便链式调用
      return this.$nextTick();
    },
    // 点击行切换选中
    toggleRowSelection(row) {
      this.$refs.shopTable.toggleRowSelection(row);
    },
    // 选择变化 - 合并当前页选择状态和已缓存的跨页选择状态
    onSelectionChange(selection) {
      // 如果正在忽略 selection-change 事件，直接返回
      if (this.ignoreSelectionChange) {
        console.log('onSelectionChange ignored');
        return;
      }

      console.log('onSelectionChange - selection:', selection.length, 'currentSelection:', this.currentSelection.length);

      const currentPageIds = new Set(this.pagedShopList.map(row => String(row.shopId || row.id)));
      // 保留其他页的选择，只更新当前页
      const otherPageSelection = this.currentSelection.filter(
        s => !currentPageIds.has(String(s.shopId || s.id))
      );
      // 合并
      this.currentSelection = [...otherPageSelection, ...selection];
      console.log('onSelectionChange - updated currentSelection:', this.currentSelection.length);
    },
    // 获取行唯一键
    getRowKey(row) {
      return row.shopId || row.id;
    },
    // 计算序号
    calcIndex(index) {
      return (this.page - 1) * this.size + index + 1;
    },
    // 分页变化
    onSizeChange(newSize) {
      this.ignoreSelectionChange = true;
      this.size = newSize;
      this.page = 1;
      this.updatePagedData().then(() => {
        this.syncPageSelection();
      });
    },
    onPageChange(newPage) {
      this.ignoreSelectionChange = true;
      this.page = newPage;
      this.updatePagedData().then(() => {
        this.syncPageSelection();
      });
    },
    // 搜索
    doSearch() {
      this.ignoreSelectionChange = true;
      this.page = 1;

      // 过滤掉 shopId 为 "直营店" 和 "加盟店" 的数据
      let list = this.shopList.filter(shop => {
        const shopId = shop.shopId || shop.id;
        return shopId !== '直营店' && shopId !== '加盟店';
      });

      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase();
        list = list.filter(item => {
          const nameMatch = (item.shopName || '').toLowerCase().includes(keyword);
          const codeMatch = (item.shopId || '').toLowerCase().includes(keyword);
          return nameMatch || codeMatch;
        });
      }

      this.filteredShopList = list;
      this.updatePagedData().then(() => {
        this.syncPageSelection();
      });
    },
    // 确认
    confirmSelection() {
      this.$emit('confirm', this.currentSelection);
      this.dialogVisible = false;
    },
    // 取消
    cancelSelection() {
      this.dialogVisible = false;
      this.currentSelection = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-header {
  margin-bottom: 20px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt20 {
  margin-top: 20px;
}

.flex {
  display: flex;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.flex-between {
  justify-content: space-between;
}

.hm-pagination {
  font-family: PingFang SC;
}

.selected-info {
  font-size: 14px;
  color: #666;
  
  .highlight {
    color: #0B66EA;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
